import type { RouteObject } from 'react-router-dom';

import PaymentFailed from 'pages/payment/PaymentFailed';
import PaymentSuccess from 'pages/payment/PaymentSuccess';

export const paymentRoutes: RouteObject[] = [
  {
    path: '/payment/success',
    element: <PaymentSuccess />,
  },
  {
    path: '/payment/failed',
    element: <PaymentFailed />,
  },
];
